import { AuthErrorKind } from '@griply/types';

const MESSAGE_KEY_BY_KIND: Record<AuthErrorKind, string | null> = {
  [AuthErrorKind.Cancelled]: null,
  [AuthErrorKind.WrongCombination]: 'auth.errors.wrong-combination',
  [AuthErrorKind.EmailTaken]: 'auth.errors.email-taken',
  [AuthErrorKind.WeakPassword]: 'auth.errors.weak-password',
  [AuthErrorKind.InvalidEmail]: 'login.invalid-email',
  [AuthErrorKind.InvalidLink]: 'auth.errors.invalid-link',
  [AuthErrorKind.TooManyRequests]: 'auth.errors.too-many-requests',
  [AuthErrorKind.Network]: 'auth.errors.network',
  [AuthErrorKind.AccountDisabled]: 'auth.errors.account-disabled',
  [AuthErrorKind.DifferentSignInMethod]: 'auth.errors.different-sign-in-method',
  [AuthErrorKind.Unknown]: 'auth.errors.unknown',
};

export const getAuthErrorMessageKey = (kind: AuthErrorKind): string | null =>
  MESSAGE_KEY_BY_KIND[kind];
